import styled from "styled-components";

export const Chart = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;

  p {
    margin-top: 12px;
    margin-bottom: 0;
    font-size: 18px;
    line-height: 28px;
    text-align: center;
    font-weight: 500;
  }

  svg {
    position: relative;
    width: 150px;
    height: 150px;
    transform: rotate(-90deg);
    z-index: 1000;
    overflow: initial;
  }

  .percent {
    position: relative;
    width: 150px;
    height: 150px;
    border-radius: 50%;
    z-index: 1000;
  }
  .percent .number {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
  }
  .percent .number span {
    color: #4e4b66;
    font-weight: 700;
    font-size: 20px;
    line-height: 36px;
    transition: 0.5s;
  }
  .progress-bar__background {
    fill: none;
    stroke: #eff0f6;
    stroke-width: 3;
  }
  .progress-bar__progress {
    fill: none;
    stroke: #e2eff0;
    stroke: ${(props) => props.theme.colors.primary};
    stroke-dasharray: 100 100;
    stroke-dashoffset: 31;
    stroke-linecap: round;
    stroke-width: 3;
    transition: stroke-dashoffset 1s ease-in-out;
  }
`;
